<template>
  <div class="scroll-progress-wrapper">
    <div class="scroll-progress">
      <div class="scroll-progress-inner">
        <div
          class="scroll-progress-indicator"
          :style="{ width: amountScrolled }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      amountScrolled: '.5%'
    }
  },
  mounted () {
    document.addEventListener('scroll', () => this.getScrollPercent() )
  },
  methods: {
    getScrollPercent() {
      let amount
      const h = document.documentElement,
          b = document.body,
          st = 'scrollTop',
          sh = 'scrollHeight'

      amount = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100

      if (amount < 1) amount = .5

      this.amountScrolled = amount + '%'
    }
  }
}
</script>
